<template>
    <div class="ex_detail">
        <div class="ex_left br6">
            <img
                class="img"
                v-show="isImg && exData.drawingThumbnail"
                :src="exData.drawingThumbnail"
            />
            <img
                class="img"
                v-show="isImg && !exData.drawingThumbnail"
                :src="require('@i/exercise/formation_bg.svg')"
            />
            <div class="animate" v-show="isAnimate">
                <cl-svg-icon @click.native="playVideo" width="48" icon-class="sd_exercise_play"></cl-svg-icon>
            </div>
            <div class="view_tag">
                <span class="tag mr4" :class="{active: isImg}" @click="viewTag = 'img'">
                    <cl-svg-icon
                        width="18"
                        :icon-class="isImg ? 'sd_exercise_img_active' : 'sd_exercise_img'"
                    ></cl-svg-icon>
                </span>
                <span class="tag" :class="{active: isAnimate}" @click="viewTag = 'animate'">
                    <cl-svg-icon
                        width="18"
                        :icon-class="isAnimate ? 'sd_exercise_animation_active' : 'sd_exercise_animation'"
                    ></cl-svg-icon>
                </span>
            </div>
            <cl-hint class="tip" placement="top-end" page="schedule">
                <cl-svg-icon width="42" :currentColor="false" icon-class="sd_exercise_tip"></cl-svg-icon>
            </cl-hint>
        </div>
        <div class="ex_right pl60 pt40">
            <p class="Major_Color fs22 SysFontM">{{exData.title}}</p>
            <div class="mt10 Disp_AC">
                <cl-avatar :src="exData.creatorAvatar" :round="true" width="32" height="32"></cl-avatar>
                <span class="ml8 Major_Color fs14">{{exData['creatorName' + $lang]}}</span>
                <span
                    class="Tip_Color fs14 ml16 AkrobatR"
                >{{$moment(exData.createTime).format('YYYY/MM/DD HH:mm:ss')}}</span>
            </div>
            <cl-tag-group class="mt8 mb8" :list="exData.tags" view="all"></cl-tag-group>
            <p class="mt24 Major_Color fs14">{{$t('exercise.目标')}}</p>
            <div class="text SysFontM Minor_Color">{{exData.goal}}</div>
            <p class="mt24 Major_Color fs14">{{$t('exercise.内容')}}</p>
            <div class="text SysFontM Minor_Color">{{exData.desc}}</div>
            <p class="mt24 Major_Color fs14 SysFontM mb10">{{$t('schedule.附件')}}</p>
            <cl-file-list
                v-if="exData.files && exData.files.length"
                :disabled="true"
                v-model="exData.files"
            ></cl-file-list>
            <div v-else class="fs14 Gray_Color">{{$t('common.暂无数据')}}</div>
        </div>
        <el-dialog
            :visible.sync="dialogVisible"
            width="540px"
            :destroy-on-close="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <div slot="title">
                <p class="Text_Left pl24 fs14 Major_Color SysFontM">{{exData.title}}</p>
                <p
                    class="Text_Left pl24 fs14 AkrobatM mt5"
                    style="color:#705f5f"
                >{{$moment(exData.createTime).format('YYYY/MM/DD HH:mm:ss')}}</p>
            </div>
            <div>
                <video width="476" height="631" :src="exData.videoUrl" controls></video>
            </div>
        </el-dialog>
    </div>
</template>

<script>
/**
 * ComponentName: 教案详情
 * Created Date:2022/5/6
 * Author: Nancy
 * 组件说明：
 * 传入教案详情数据，展示教案详情
 * eg:
 *     <cl-ex-detail></cl-ex-detail>
 */
export default {
    name: 'cl-ex-detail',
    data () {
        return {
            viewTag: 'img', // 浏览视图
            options: [{ // 提示配置
                label: '传球/打门',
                labelEn: 'Pass/shot',
                value: '1',
                class: 'sd_exercise_pass',
            }, {
                label: '移动',
                labelEn: 'Movement',
                value: '2',
                class: 'sd_exercise_move',
            }, {
                label: '带球',
                labelEn: 'Dribbling',
                value: '3',
                class: 'sd_exercise_drib',
            }, {
                label: '拦截',
                labelEn: 'Interception',
                value: '4',
                class: 'sd_exercise_intercepte',
            }],
            dialogVisible: false, // 动画教案播放弹窗
        };
    },

    props: {
        exData: {
            type: Object,
            default: () => { }
        }
    },
    computed: {
        // 图片视图
        isImg () {
            return this.viewTag === 'img';
        },
        // 动画视图
        isAnimate () {
            return this.viewTag === 'animate'
        },
    },
    methods: {
        // 播放动画教案视频
        playVideo () {
            if (!this.exData.videoUrl) {
                this.$message.warning(this.$t("exercise.暂无动画"));
                return
            }
            this.dialogVisible = true;
        }
    }
}
</script>
<style lang='scss' scoped>
.ex_detail {
    display: flex;
    height: 479px;

    .ex_left {
        width: 362px;
        height: 100%;
        position: relative;
        overflow: hidden;

        .img {
            width: 100%;
            height: 100%;
        }

        .animate {
            width: 100%;
            height: 100%;
            background: url('../../assets/images/exercise/animate_bg.png') no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .view_tag {
            position: absolute;
            bottom: 16px;
            left: 50%;
            transform: translateX(-50%);
            background-color: rgba($color: #000000, $alpha: 0.16);
            border-radius: 27px;
            box-sizing: border-box;
            height: 36px;
            width: 120px;
            padding: 4px;

            .tag {
                display: inline-block;
                width: 54px;
                height: 28px;
                border-radius: 24px;
                text-align: center;
                box-sizing: border-box;
                padding-top: 5px;

                &.active {
                    background-color: #fff;
                }
            }
        }

        .tip {
            position: absolute;
            bottom: 0;
            right: 0;
        }
    }

    .ex_right {
        box-sizing: border-box;
        flex: 1;
        overflow: hidden;
        overflow-y: auto;
        .text {
            font-size: 14px;
            line-height: 26px;
            margin-top: 8px;
            width: 100%;
            word-break: break-word;
        }
    }
}
</style>
